import { render, staticRenderFns } from "./CompSupportModal.vue?vue&type=template&id=77e8bfb7"
import script from "./CompSupportModal.vue?vue&type=script&lang=js"
export * from "./CompSupportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports